import React from 'react';
import FormError from '../../../FormError';

function fieldError(errors, field) {
    return errors && errors[field] && errors[field][0];
}

export default function BusinessDetailsFields({ values, onChange, errors, industries, canOverride }) {
    return (
        <div className="demo-add-details-fields" data-testid="demo-add-details">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="demo-add-details-industry">{__('Industry')}</label>
                        <select
                            id="demo-add-details-industry"
                            className="form-control"
                            value={values.industry_id || ''}
                            onChange={(event) => onChange('industry_id', event.target.value)}
                        >
                            <option value="">{__('Select an industry')}</option>
                            {industries.map((industry) => (
                                <option key={industry.id} value={industry.id}>{industry.name}</option>
                            ))}
                        </select>
                        {!values.industry_id &&
                            <p className="text-danger small mb-0 mt-1" data-testid="demo-add-industry-required-hint">
                                {__('Select an industry to continue.')}
                            </p>
                        }
                        <FormError error_message={fieldError(errors, 'industry_id')} />
                    </div>
                </div>
            </div>

            {canOverride &&
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="demo-add-details-address">{__('Address')}</label>
                            <input
                                id="demo-add-details-address"
                                type="text"
                                className="form-control"
                                value={values.address || ''}
                                onChange={(event) => onChange('address', event.target.value)}
                            />
                            <FormError error_message={fieldError(errors, 'address')} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="demo-add-details-phone">{__('Phone')}</label>
                            <input
                                id="demo-add-details-phone"
                                type="text"
                                className="form-control"
                                value={values.phone || ''}
                                onChange={(event) => onChange('phone', event.target.value)}
                            />
                            <FormError error_message={fieldError(errors, 'phone')} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="demo-add-details-display-url-as">{__('Display URL as')}</label>
                            <input
                                id="demo-add-details-display-url-as"
                                type="text"
                                className="form-control"
                                value={values.display_url_as || ''}
                                onChange={(event) => onChange('display_url_as', event.target.value)}
                            />
                            <FormError error_message={fieldError(errors, 'display_url_as')} />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="demo-add-details-name">{__('Name')}</label>
                            <input
                                id="demo-add-details-name"
                                type="text"
                                className="form-control"
                                value={values.name || ''}
                                onChange={(event) => onChange('name', event.target.value)}
                            />
                            <FormError error_message={fieldError(errors, 'name')} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="demo-add-details-url">{__('URL')}</label>
                            <input
                                id="demo-add-details-url"
                                type="text"
                                className="form-control"
                                value={values.url || ''}
                                onChange={(event) => onChange('url', event.target.value)}
                            />
                            <FormError error_message={fieldError(errors, 'url')} />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
